let content = [
    {
      id: "general_trading_conditions",
      title: "Общие условия торговли",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "Детали продукта",
          content_before: `<p class="mb-5">
                           iFOREX предлагает высококонкурентные условия для маржинальной торговли CFD с использованием кредитного плеча на основе различных базовых активов («Базовые активы»), включая валютные пары (Форекс), товары, индексы, акции, ETF и криптовалюты («Инструменты» или «Финансовые инструменты» или « Инструменты с кредитным плечом» или «CFD» в зависимости от контекста).
                            <br><br>
                            <b>Спреды</b><br>Спред определяет стоимость торговли - это разница между ценой Продажи (Bid) и ценой Покупки (Ask). Например, если цена продажи валютной пары USD/JPY составляет 101.202, а цена покупки составляет 101.222, то разница между этими двумя ценами называется спред. В данном примере спред составляет 2 пункта.
                            <br><br>
                            <b>Маржа и кредитное плечо</b><br>Маржа служит залогом на случай понесенных Вами убытков и позволяет совершать сделки на суммы, значительно превышающие фактический баланс на Вашем счете. Таким образом, Вы получаете возможность заработать гораздо больше, чем если бы торговали только за счет собственных средств.
                            <br><br>
                            Однако, кредитное плечо – это палка о двух концах. С помощью заемных средств можно не только приумножить свою прибыль, но также легко приумножить убытки. Когда Вы используете слишком большое кредитное плечо, убыточные позиции могут быстро свести к нулю прибыль по множеству других сделок. Маржевая торговля несет в себе высокую степень риска и подходит далеко не всем инвесторам.
                            <br><br>
                            Открыв счет на iFOREX, Вы попадете под нашу программу защиты от отрицательного баланса. Это означает, что Вы никогда не потеряете больше, чем вложили, несмотря на то, что даже небольшие движения рынка могут привести к существенным потерям средств. Наша торговая платформа автоматически рассчитывает обязательную для Вас маржу перед исполнением любого ордера, а также проверяет остаток доступных средств на счету перед тем, как обработать запрос о выводе денег.
                            <br><br>
                           Маржинальные требования актуальны в случае возникновения финансовой уязвимости счёта, в результате открытия/закрытия сделок или попытки снятия средств при наличии открытых позиций. Маржинальные требования отражают уровень риска позиции и определяются на основе уровня волатильности, ликвидности и особенностей ценообразования определенного типа актива. 
                            </p>
                            <span id="product_section"></span>
                            <p class="tc-inner-link"><a href="/торговые-условия/валюты">Валюты</a></p>
                            <p class="tc-inner-link"><a href="/торговые-условия/товары">Товары</a></p>
                            <p class="tc-inner-link"><a href="/торговые-условия/индексы">Индексы</a></p>
                            <p class="tc-inner-link"><a href="/торговые-условия/акции">Акции</a></p>
                            <p class="tc-inner-link"><a href="/торговые-условия/etfs">ETFs</a></p>
                            <p class="tc-inner-link"><a href="/торговые-условия/crypto">Crypto</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "Часы торговли",
          content_before: `<p>
                Во время европейской и североамериканской зимы, торги открываются в воскресенье в 22:05 GMT и закрываются в пятницу в 21:00 GMT. При переходе на летнее время в этих регионах, торги открываются в воскресенье в 21:05 GMT и закрываются в пятницу в 20:00 GMT. Часы активности рынка могут отличаться в зависимости от государственных праздников или в связи с нестандартными условиями ликвидности, которые могут возникнуть в результате чрезвычайных глобальных событий. Время открытия или закрытия торгов также может быть изменено компанией iFOREX в результате ликвидности и управления рисками.
                <br><br>
                Несмотря на то, что большинство инструментов доступны для торговли 24 часа в сутки, некоторые инструменты имеют определённые часы торговли, указанные в таблице ниже:
              </p>`,
  
          data_id: "TradingHours",
          products: {
            1:"Валюты и Крипто",
            2:"Товары",
            3:"Индексы",
            4:"Акции",
            5:"Metals",
            8:"ETFs"
          },
          table_titles: [
            "Рынок",
            "Часы торговли (GMT)",
            "1-й дневной перерыв (GMT)",
            "2-й дневной перерыв (GMT)",
            "Данные действительны до (GMT)"
          ],
          content_after: `<p>Не знаете, к какому рынку относится инструмент, который вы ищите? Нажмите здесь, чтобы ознакомиться с <span class="tclink" target-tab="tc-view-6">полным списком инструментов по каждому рынку</span>.</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "Праздники",
          content_before: `<p>
                Чтобы убедиться, что вы в курсе всех часов ведения торгов на рынке, и осведомлены о предстоящих праздниках, пожалуйста посмотрите приведённый ниже список событий.<br>
                В iFOREX мы прикладываем все возможные усилия, чтобы предоставленная вам информация была актуальной и обновлённой.<br>
                Если вы хотите получить более подробную информацию, пожалуйста, свяжитесь с нашим дилинговым центром.
                </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "Рынок",
            "Торги прекращаются в (GMT)",
            "Торги возобновляются в (GMT)",
          ],
          content_after: `<p>Не знаете, к какому рынку относится инструмент, который вы ищите? Нажмите здесь, чтобы ознакомиться с <span class="tclink" target-tab="tc-view-6">полным списком инструментов по каждому рынку</span>.</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "Ордера и исполнение",
          content_before: `<p><b>Типы ордеров</b></p>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>РЫНОЧНЫЕ ОРДЕРА</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Открыть сделку</td>
                   <td>Ордер на открытие позиции по текущему доступному рыночному курсу</td>
                </tr>
                <tr>
                   <td>Закрыть сделку</td>
                   <td>Ордер на закрытие позиции по текущему доступному рыночному курсу</td>
                </tr>
             </tbody>
          </table>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>ЛИМИТ ОРДЕРА</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Стоп-лосс</td>
                   <td>Стоп-лосс является ордером (приказом) открыть или закрыть сделку по курсу который ниже рыночного текущего.</td>
                </tr>
                <tr>
                   <td>Тэйк-профит</td>
                   <td>Тэйк-профит является ордером (приказом) открыть или закрыть сделку по курсу который выше рыночного текущего.</td>
                </tr>
             </tbody>
          </table>
          <p>
             <b>Рыночные ордера</b><br>Рыночные Заказы (торговые запросы, т.е. открыть сделку, закрыть сделку) исполняются по цене, которая производится на торговой платформе компании (со стороны клиента) в точном времени исполнения, при условии, что такая цена находится в пределах заданного допустимого уровня от базовой цены, указанная в сервере компании и независимо от того, если базовая цена выше или ниже цены, указанной на торговой платформе (Что вы видите, то вы и получаете, или ЧВВТВИП). В том случае, если цена, указанная на торговой платформе (со стороны клиента) превышает указанный допустимый уровень, например, из-за движений базовых активов тем временем как клиент разместил свой заказ, и временим получения и выполнения заказа, высокая волатильность рынка и в связи задержкой, заказ будет исполнен по цене, указанной по серверу Компании, которая должна отличаться от цены, указанной в торговой платформе (рыночная цена), на симметричной основе. В случае существенной разницы между ценой, указанной на (стороне клиента) торговой платформы и по цене, указанной на серверах компании, Орден должен быть отклонен.
          </p>
          <p>
             <b>Лимит ордера</b><br>Лимит Ордера (будущие заказы) выполняются по рыночной цене, указанной на сервере компании, которая может отличаться от цены, указанной в заказе ("Проскальзывание"). Проскальзывание может произойти в том случае, когда цена, указанная в заказе не доступна на сервере, например, из-за высокой волатильности или разрыве в рыночных ценах. В таком случае, заказ будет выполнен по первой доступной цене, независимо от направления проскальзывания, либо в пользу клиента или нет, в симметричной и прозрачной основе (Симметричное Проскальз).<br><br>Инструменты (например, акции, индексы и ETF на основе CFD), которые не торгуются на индивидуальной основе 24 часов, могут возникнуть разрыв рынка на ежедневной основе, и, следовательно, более восприимчивы к скольжению. Важно отметить, что проскальзывание не влияет на отрицательный результат защиты баланса и, следовательно, клиент никогда не потеряет больше, чем сумма его вложений (включая любую прибыль, если получили), даже если происходит проскальзывание.
          </p>
          <p>
             <b>Задержки в исполнении</b><br>Задержка в исполнении может произойти по различным причинам, например, при возникновении технических неполадок с интернетом клиента, мобильным или другим коммуникационным подключением к серверам iFOREX, которые могут привести к "висячему ордеру". Нарушение в путях соединения могут временами прерывать сигнал и отключать платформу, вызывая задержки при передаче данных между платформой трейдера и сервером iFOREX.
          </p>
          <p>
             <b>Висячие ордера</b><br>В периоды большого объема торгов или при коммуникационной задержке, могут возникнуть висячие заказы (очередь Лимит ордеров). Такое увеличение в поступающих ордерах может создать условия, при которых будет задержка в подтверждении/обработке определенного лимит ордера. В отдельных случаях, позиция может фактически были выполнена, а задержка будет попросту на дисплее клиента из-за сильного интернет трафика.<br><br>Имейте в виду, что любой ордер нужно устанавливать только один раз. Множественные записи одного и того же ордера могут замедлить или заблокировать компьютер, или непреднамеренно открыть нежелательные позиции.
          </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "Защита от отрицательного баланса",
          content_before: `<p class="">
                Политика защиты от отрицательного баланса, установленная компанией iFOREX, гарантирует, что возможные потери не могут превысить сумму инвестированную клиентом на свой счёт. При данных условиях, в случае потерь при ведении торгов, клиент никогда не столкнётся с отрицательным балансом. Торгуя с iFOREX, возможные потери клиента ограничены суммой инвестированных средств и суммой дополнительных средств, которые являются прибылью, полученной прежде при торгах, если таковые имеются.
              </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "bonus_terms_and_conditions",
          id:'btc',
          title: "Условия Бонусной Программы",
          content_before: `<p>
          <b>ВСТУПЛЕНИЕ</b><br>Данные Условия относятся к Торговому бонусу, включая приветственный бонус, Бонус Cashback и Бонус Пробного аккаунта, которые предлагаются Компанией, (далее именуется "Бонус"), как описано ниже, и считаются неотъемлемой частью Условий Компании. Все толкования терминов в этом тексте, находятся в тексте Условий Компании, который доступен на веб-сайте Компании <a href="/">www.iforexru.com</a>.</p>
          <p>
             <b>УСЛОВИЯ ПОЛУЧЕНИЯ ПРЕДЛОЖЕНИЯ</b><br>Бонусы доступны клиентам Компании, которые проходят по критериям приемлемости соответствующего предложения, проходят все необходимые процедуры регистрации в соответствии с требованиями Компании, которые периодически изменяются по собственному усмотрению Компании, и одобрены Компанией в качестве подходящих клиентов. ("<b>Правомочные клиенты</b>").
             <br><br>
             Компания может предлагать любые Бонусы по своему усмотрению, любому Клиенту и / или в любой стране / регионе, как сочтет это целесообразным.
             <br><br>
             Компания оставляет за собой право, по своему усмотрению, отклонять регистрацию любого пользователя, в том числе Соответствующих Клиентов, по Бонусной программе и / или отзывать предложение любого Бонуса по своему усмотрению.<br><br>Резиденты из ограниченных юрисдикцией стран, включая резидентов США, не имеют права на получение Торгового Бонуса.
          </p>
          <p><b>ТОРГОВЫЙ БОНУС</b><br>В соответствии с Общими Условиями Настоящего Соглашения, Торговый Бонус предоставляется Правомочным клиентам в виде процента от суммы средств, внесенных на их торговый счет, и / или иным образом, как Компания может посчитать нужным по своему собственному усмотрению.
             <br><br>
             Торговый бонус предназначен только для целей маржинальной торговли, поэтому может использоваться только как дополнительная маржа (т. е. Клиент не сможет снять предоставленный Бонус).
             <br><br>
             Торговый бонус предоставляется каждому Соответствующему Клиенту.
             <br><br>
             Приветственный бонус - это торговый бонус для новых клиентов делующих первый раз депозит.
          </p>
          В случаях, когда торговый бонус предоставляется на основании депозита, внесенного на счет, применяются следующие условия
                      <br>
                      <ol>
                      <li class="mb-0 mt-1">В случае полного снятия средств - весь торговый бонус будет удален</li>
                      <li>В случае частичного вывода капитала - сумма торгового бонуса будет скорректирована до 20% от капитала, оставшегося на счете после вывода, или по иному решению Компании по своему усмотрению с момента ко времени.</li>
                      </ol>
          <u style="font-style:italic">Пример</u><br><br>
          Соответствующий Клиент, согласовал с Компанией получение 30% Бонуса на свой депозит в 1,000$. Соответствующий клиент получит дополнительную Маржу на сумму 300$ (т. е. 30% от своего депозита) в виде Торгового Бонуса.<br><br>Данный бонус будет отражен на счёте клиента следующим образом:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>Баланс</th>
                      <th>Ликвидные средства</th>
                      <th>Доступная Маржа</th>
                      <th>Торговый Бонус</th>
                   </tr>
                   <tr>
                      <td>1,000$</td>
                      <td>1,000$</td>
                      <td>1,300$</td>
                      <td>300$</td>
                   </tr>
                </tbody>
             </table>
          </div>
          Торговый бонус не будет доступен для снятия, в любой ситуации. Любая прибыль, полученная Соответствующим клиентом, путем использования Торгового Бонуса, будет доступна для снятия, в соответствии с политикой Компании в отношении снятия средств и действующим законодательством. Прибыль, подлежащая снятию, вне Торгового Бонуса, будет видна в разделе «Баланс» но торговом аккаунте клиента.
          <br><br>
          <u style="font-style:italic">Пример</u><br><br>
          Соответствующий Клиент согласовал с Компанией получить 30% бонус на свой депозит в 1,000$. Соответствующий Клиент имеет приведённые ниже Ликвидные средства и Баланс на своём аккаунте:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>Баланс</th>
                      <th>Ликвидные средства</th>
                      <th>Доступная Маржа</th>
                      <th>Торговый Бонус</th>
                   </tr>
                   <tr>
                      <td>1,000$</td>
                      <td>1,000$</td>
                      <td>1,300$</td>
                      <td>300$</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">Сценарий А</u><br><br>
          Клиент запросил снять всю сумму его депозита (1,000 $). Торговый бонус будет полностью удалён.<br><br>Это будет отражаться на аккаунте клиента следующим образом:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>Баланс</th>
                      <th>Ликвидные средства</th>
                      <th>Доступная Маржа</th>
                      <th>Торговый Бонус</th>
                   </tr>
                   <tr>
                      <td>0$</td>
                      <td>0$</td>
                      <td>0$</td>
                      <td>0$</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">Сценарий Б</u><br><br>
          Клиент запросил снятие 800$, в связи с чем ликвидные средства клиента были уменьшены до 200$, и Торговый Бонус в этом случае ограничен до 20% суммы Ликвидных Средств т.е. 40$.
          <br><br>Это будет отражаться на счете клиента следующим образом:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>Баланс</th>
                      <th>Ликвидные средства</th>
                      <th>Доступная Маржа</th>
                      <th>Торговый Бонус</th>
                   </tr>
                   <tr>
                      <td>200$</td>
                      <td>200$</td>
                      <td>240$</td>
                      <td>40$</td>
                   </tr>
                </tbody>
             </table>
          </div>
          Все Торговые Бонусы ,будут аннулированы, если счет останется неактивным в течение 7 последовательных недель.
          <br><br>
          <p><b>CASH BACK</b><br>
             По бонусной программе CashBack, каждую неделю на торговый счёт Соответствующих Клиентов начисляются денежные средства, в соответствие с совершённым объёмом торгов в прошедшую неделю и до определённой суммы, установленной заранее Компанией (“Ожидаемый Бонус”).<br><br>Сумма Ожидаемого Бонуса может зависеть от определенного депозита или нескольких депозитов, высчитывается как процент от суммы депозита, или определяется по усмотрение Компании.
          </p>
          <u style="font-style:italic">Пример</u><br><br>
          Соответствующий Клиент, который сделал депозит в 1,000$, получил право на денежный бонус по программе Cash Back, до 40% от суммы его депозита, за объём торгов в 20,000,000$. Такой клиент получит 400$ в качестве Ожидаемого Бонуса.<br><br>Это Ожидаемый Бонус будет отражаться на счете Клиента следующим образом:
          <div class="table-wrapper">
             <table class="table2 mt-3 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>Баланс</th>
                      <th>Ликвидные средства</th>
                      <th>Доступная Маржа</th>
                      <th>Ожидаемый Бонус</th>
                      <th>Объём совершённых торгов</th>
                      <th>Необходимый объём торгов</th>
                   </tr>
                   <tr>
                      <td>1,000$</td>
                      <td>1,000$</td>
                      <td>1,000$</td>
                      <td>400$</td>
                      <td>0$</td>
                      <td>20,000,000$</td>
                   </tr>
                </tbody>
             </table>
          </div>
          Каждую неделю, Pеализованный бонус CashBack, который рассчитывается по недельному объему торгов клиента, вычитается из общей суммы CashBack (Ожидаемого Бонуса) и зачисляется на счет клиента. Расчёт реализованного бонуса происходит таким образом: соотношение объёма торгов совершённых за неделю (в долларах США) к требуемому объем торгов, как указано на торговой платформе. Уточним, что клиент имеет право только на реализованный CashBack, Ожидаемый Бонус реализуется только после того, как клиент завершает требуемый объем торгов. Сумма CashBack ("Реализованный CashBack") ограничивается суммой Ожидаемого Бонуса, выделенного клиенту.<br><br>Объем торгов рассчитывается по принципу "открытие и закрытие", а это означает, что открытие позиции на сумму 1 миллион $ (или в другом валютном эквиваленте) и закрытие той же позиции, считается как совершённый объём торгов в 2 миллиона $ (или в другом валютном эквиваленте).
          <br><br>
          <u style="font-style:italic">Пример</u><br><br>
          <u style="font-style:italic">Сценарий А</u><br><br>
          Соответствующему Клиенту, в предыдущем примере, было предложено 100$ Реализованного CashBack за каждые 5 миллионов $ объёма торгов. После 1 недели, он достиг объём торгов в 5 миллионов долларов. Поэтому, 100$ Реализованного CashBack были перечислены с Ожидаемого Бонуса в Ликвидные средства.
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>Баланс</th>
                      <th>Ликвидные средства</th>
                      <th>Доступная Маржа</th>
                      <th>Ожидаемый Бонус</th>
                      <th>Объём совершённых торгов</th>
                      <th>Необходимый объём торгов</th>
                   </tr>
                   <tr>
                      <td>1,100$</td>
                      <td>1,100$</td>
                      <td>1,100$</td>
                      <td>300$</td>
                      <td>5,000,000$</td>
                      <td>20,000,000$</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">Сценарий Б</u><br><br>
          Прошло 2 недели после депозита, клиент активно торговал и достиг 5 миллионов $ объёма, а также его торги принесли прибыль в 300$. Поэтому дополнительные 100$ Реализованного CashBack были перечислены с Ожидаемого Бонуса в Ликвидные средства.<br><br>Это будет отображено в аккаунте Клиента следующим образом:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>Баланс</th>
                      <th>Ликвидные средства</th>
                      <th>Доступная Маржа</th>
                      <th>Ожидаемый Бонус</th>
                      <th>Объём совершённых торгов</th>
                      <th>Необходимый объём торгов</th>
                   </tr>
                   <tr>
                      <td>1,500$</td>
                      <td>1,500$</td>
                      <td>1,500$</td>
                      <td>200$</td>
                      <td>10,000,000$</td>
                      <td>20,000,000$</td>
                   </tr>
                </tbody>
             </table>
          </div>
          После зачисления в Ликвидные средства, Реализованный CashBack может быть использован для торговли или может быть снят Клиентом в любое время. Любая прибыль, сделанная с помощью инвестиции Реализованного CashBack, также может быть снята Соответствующим Клиентом.<br><br>Бонусная программа CashBack имеет временное ограничение. Клиент может получать Реализованный CashBack в течение первых 3 месяцев, после зачисления Ожидающего Бонуса. Клиент может получить бонус по программе CashBack, и в дальнейшем, при совершении следующего депозита.
          <br><br>
          <u style="font-style:italic">Пример</u><br><br>
          Соответствующий Клиент, в предыдущем примере, принял решение снять заработанную прибыль в 300$ и 200$ Реализованного CashBack, который был ему зачислен. Поэтому он подал запрос на снятие средств на сумму 500$. Бонус CashBack, который не был реализован, и составляет 200$ останется в виде Ожидаемого Бонуса на его аккаунте. Поэтому Клиент может продолжать торговлю, используя 1,000$, а также у него осталось время - 2 с половиной месяца, чтобы реализовать оставшийся Ожидаемый Бонус в реальные средства (в Реализованный CashBack).<br><br>Это будет отображено в аккаунте Клиента следующим образом:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>Баланс</th>
                      <th>Ликвидные средства</th>
                      <th>Доступная Маржа</th>
                      <th>Ожидаемый Бонус</th>
                      <th>Объём совершённых торгов</th>
                   </tr>
                   <tr>
                      <td>1,000$</td>
                      <td>1,000$</td>
                      <td>1,000$</td>
                      <td>200$</td>
                      <td>10,000,000$</td>
                   </tr>
                </tbody>
             </table>
          </div>
          Бонус CashBack зачисляется в валюте аккаунта.
          <br><br>
          <p>
             <b>ПРОБНЫЙ АККАУНТ</b><br>
             Пользователям может быть предоставлен пробный аккаунт, который включает в себя торговый бонус (как описано выше) 25$, которые могут быть использованы для торговли - в соответствии с Торговыми условиями Компании.
             <br><br>
             Пробный аккаунт истекает в течение 3-х дней со дня первой сделки и все ожидающие транзакции на пробном счете завершаются ("Пробный период"). Любое количество, которое превышает 25 долларов США ("Профит") могут быть использованы в качестве маржи на торговом счету с Компанией, при условии успешного завершения пользовательского процесса регистрации и минимальным депозитом в размере 100 долларов США, или могут сняться на счет в банке под именем пользователя. Обратите внимание, что (i) снятия подлежат процедуре снятия Компании и может дополнительно взиматься сбор за перевод и (ii )любая Прибыль, которая не снимается или не переводится на торговый счет и используется в качестве маржи для торговых целей, не позднее 14 дней с даты открытия первой транзакции на Пробном счете, должна быть аннулирована.
             <br><br>
             Бонус доступен только для клиентов которые регистрируются на платформе Компании впервые и соответствуют критериям, как описано выше. Один пользователь/одна семья/один IP-адрес - могут получить только один бонус.
          </p>
          <p>
             <b>ОБЩИЕ УСЛОВИЯ</b><br>
             Любое указание или подозрение, по усмотрению Компании, на любую форму незаконных, недобросовестных и\\или оскорбительных методов торговли (в том числе, но не ограничиваясь, паттерны торговой активности которые указывают на цель получить финансовую выгоду от Торгового Бонуса, не принимая рыночный риск и\\или открытие, эксплуатация или управление несколькими аккаунтами одним клиентом), а также какое-либо указание или подозрение на мошенничество, манипуляцию или нарушение договоров Компании, политики и условий по отношению к Бонусной Схеме, приведут к аннулированию всех бонусов, ранее зачисленных на торговый счёт и в отношении любого соответствующего аккаунта. При таких обстоятельствах, Компания имеет право по своему собственному усмотрению, и без отступления от своих прав указанных в торговом соглашение с клиентом и действующим законодательством, аннулировать и отменить все осуществлённые транзакции и/или прибыль или убытки полученные в них, и  заблокировать все соответствующие учетные записи, и Компания не несет ответственности за любые последствия любого из указанных действий.
             <br><br>
             Компания оставляет за собой право, как она по своему усмотрению сочтет нужным, изменить, приостановить, отменить или прекратить вышеупомянутую бонусную программу, или любой аспект вышеупомянутого предложения, в любое время.
          </p>`,
          data_id: "",
          content_after: "",
        },
        {
         //id: "margin_information",
         id:'tc-view-24',
         title: "Информации о марже",
         content_before: `
                     <p>
                     Окно, которое вы увидите ниже, содержит подробную информацию относительно маржи торгового счёта:
                     <div class="table-wrapper">
                        <table class="table3 mt-4 mb-4">
                           <tbody>
                              <tr>
                                 <td>Ликвидные средства</td>
                                 <td style="">4995</td>
                              </tr>
                              <tr>
                                 <td>Использованная маржа</td>
                                 <td style="">2,500</td>
                              </tr>
                              <tr>
                                 <td>Доступная маржа</td>
                                 <td style="">2,495</td>
                              </tr>
                              <tr>
                                 <td>Применяемая маржа</td>
                                 <td style="color:green">+50.05%</td>
                              </tr>
                              <tr>
                                 <td>Поддерживаемая маржа</td>
                                 <td style="">500</td>
                              </tr>
                              <tr>
                                 <td>Сумма открытых позиций</td>
                                 <td>250000</td>
                              </tr>
                              <tr>
                                 <td>Маржинальный Запас</td>
                                 <td>+1.998%</td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                     <ul class="list-style-disc-small mb-3">
                        <li><b>Использованная маржа</b> показывает сумму Ликвидных Средств на счету, которая в настоящее время используется как Маржа для ваших Открытых Сделок. В случае, когда Используемая Маржа равна или больше, чем Ликвидные Средства, это означает, что кредитное плечо учетной записи является Максимизированным. Во время торговых перерывов Требуемая Маржа некоторых инструментов (как указано в «Таблице сведений о продукте») увеличивается - и это влияет на Доступную Маржу, которая может быть резко уменьшена в выходные дни.
                        <br>
                        Используемая Маржа = Сумма открытых позиций в инструменте x Требуемая Маржа для этого инструмента
                        </li>
                        
                        <li><b>Доступная маржа</b> показывает сумму средств на счету, что в настоящее время не используется и доступна для дальнейшего увеличения суммы открытых позиций. Когда доступная маржа равна нулю, то это указывает на максимальное использование кредитного плеча.
                       <br>
                       Доступная маржа=Ликвидные средства-Использованная маржа
                       </li>
                        
                        <li><b>Применяемая маржа</b> показывает процентное соотношение Ликвидных Средств, которая используется как Маржа для текущих Открытых Сделок. 100% Применяемая маржа и выше, указывает на максимальное использование кредитного плеча на счету.
                        <br>
                        Применяемая Маржа % = (Используемая маржа/Ликвидные Средства) x 100</li>
                        
                        <li><b>Поддерживаемая маржа</b> отражает 20 % от Использованной Маржи, необходимой для поддержания открытых сделок на счете. Когда средства счета достигают или падают ниже определенной поддерживающей маржи, автоматически активируется защита от закрытия маржи (как определено ниже).
                        <br>
                        Поддерживаемая маржа = Использованная маржа X на процент (%), определенный в Торговой Платформе.
                       <br>
                        iFOREX оставляет за собой право, но не обязана устанавливать и/или изменять поддерживающую маржу по своему усмотрению.</li>
                        
                        <li><b>Маржинальный запас</b> показывает какой процент от суммы открытых позиций на счету удерживается в ликвидных средствах в качестве залога.
                       <br>Маржинальный запас = Ликвидные средства/Сумма открытых позиций
                       </li>
                     </ul>
                     <b>Маржинальная Защита от закрытия</b><br> Если капитал клиента достигает или падает ниже уровня поддерживающей маржи, iFOREX автоматически закроет сделку, которая потребляет наибольшее количество использованной маржи, чтобы достичь минимально возможной поддерживающей маржи, затрагивая только открытые сделки на инструменты, доступные в соответствующие часы торговли. Если в данный момент открытых сделок нет, первым автоматически закрывается первый инструмент, получивший котировку. При наличии нескольких сделок (более одной), которые одинаково потребляют наибольшую сумму использованной маржи. Компания автоматически закроет сделку, которая была открыта первой. В случае, если минимально возможная поддерживающая маржа не может быть достигнута путем автоматического закрытия одной сделки, iFOREX автоматически закроет все открытые сделки по конкретному инструменту.<br>
                    iFOREX позволяет клиентам в полной мере использовать нереализованную прибыль от открытых сделок для поддержки убыточных сделок. 

                     <br><br>
                     <b><u><u>Примеры Маржинальной Защиты от закрытия</u></u></b><br>
                     Для целей настоящего документа Поддерживаемая маржа = Используемая маржа x 20%.

                   <br><br>
                     <b>Пример I: Несколько сделок (без Торгового Бонуса)</b><br>
                     В этом примере задействован клиент с несколькими открытыми сделками. Средства счета падают до уровня поддерживающей маржи.<br><br>
                     <ul class="list-style-disc-small mb-3">
                        <li>Открытые сделки:</li>
                        <ul class="list-style-disc-small empty-disc ml-4">
                           <li>1 сделка USD/JPY: куплено 200 000$ по курсу 150,22 (Использованная маржа = 0,25% x 200 000$ = 500$).</li>
                           <li>1 сделка с золотом: куплено 100 унций по курсу 2300,00 (использованная маржа = 0,5% x 100 x 2300,00$= 1150$).</li>
                           <li>1 сделка с нефтью WTI: куплено 500 баррелей по курсу 70,00 (использованная маржа = 1% x 500 x 70$= 350$).</li>
                        </ul>
                        <li><b>Общая использованная маржа:</b> 2000$.</li>
                        <li><b>Уровень поддерживающей маржи:</b> 400$.</li>
                     </ul>
                     
                     <p><b>Процесс:</b></p>

                     <ol>
                       <li>Когда капитал счета падает до или ниже 400$, система закрывает сделку, используя наибольшую использованную маржу (золото). Это снижает использованную маржу до 850$, а поддерживающую маржу - до 170$.</li>
                       <li>Если капитал упадет до 170$ или ниже, система закроет сделку USD/JPY, уменьшив используемую маржу до 350$ и поддерживающую маржу до 70$.</li>
                       <li> Наконец, если капитал упадет до 70$ или ниже, система закроет последнюю оставшуюся сделку (нефть WTI).</li>

                     </ol>
                     <b>Пример II: Единая сделка (включая торговый бонус)</b><br>
                     В этом примере рассматривается клиент с одной открытой сделкой, торговым бонусом и капиталом на уровне или ниже Поддерживаемой Маржи.<br><br>
                     <ul class="list-style-disc-small mb-3">
                       <li>Депозит: 1000$ (со 100% торговым бонусом)</li>
                       <li>Общий капитал: 2000$</li>
                       <li>Открытая сделка: куплено 800 000$ в USD/JPY.</li>
                       <li>Использованная Маржа: 0,25% x 800 000$ = 2000$.</li>
                       <li>Уровень поддерживающей маржи: 400$.</li>
                     </ul>
                     
                     <p><b>Процесс:</b> Когда капитал падает до 600$ или ниже, что приводит к достижению уровня общего капитала в 400$, система закрывает единственную открытую сделку.</p>
                     
                     <b>Пример III: Несколько сделок (включая торговый бонус)</b><br>

                     Клиент имеет несколько открытых сделок с торговым бонусом и капиталом на уровне или ниже Поддерживаемой Маржи.<br><br>

                     <ul class="list-style-disc-small mb-3">
                       <li><b>Депозит:</b> 1000$ (со 100% торговым бонусом)</li>
                       <li><b>Общий капитал:</b> 2000$</li>
                        <li><b>Открытые сделки:</b></li>
                        <ul class="list-style-disc-small empty-disc ml-4">
                           <li> 1 сделка USD/JPY: куплено 400 000$ по курсу 150,22 (Использованная маржа = 0,25% x 400 000$= 1 000$).</li>
                           <li> 1 сделка с нефтью WTI: куплено 1000 баррелей по курсу 85,00 (использованная маржа = 1% x 1000 x 85$ = 850$).</li>
                        </ul>
                        <li><b>Общая использованная маржа:</b> 1,850$</li>
                        <li><b>Уровень Поддерживающей Маржи:</b> 370$</li>
                     </ul>
                     <p>
                     <b>Процесс:</b></p>
                       <ol>
                           <li>Когда капитал упадет до 630$ или ниже, что приведет к тому, что общий капитал составит 370$, сделка USD/JPY будет закрыта.</li>
                           <li>После закрытия сделки USD/JPY используемая маржа теперь составляет 850$, а уровень поддерживающей маржи составляет 170$ (850$ x 20%).</li>
                           <li>Если капитал упадет до 830$ (общий капитал = 170$), система закроет сделку по нефти WTI.</li>
                       </ol>
                     
                     </p>`,
         data_id: "",
         content_after: "",
       },
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "Дополнительные правила торговли",
          content_before: `
              <p>
              <b>Максимальная сумма позиций</b><br>
              В благоразумных целях, направленных на улучшение управления рисками и для того, чтобы предотвратить возможность чрезмерного влияния одного клиента, компания iFOREX установила максимальную сумму позиций для каждого клиента на уровне 15 (пятнадцать) миллионов долларов США. Также, компания iFOREX определила максимальную сумму открытых позиций для каждого инструмента. Чтобы посмотреть макс. сумму открытых позиций установленную на различные инструменты <span class="tclink" target-tab="tc-view-6" target-section="product_section">нажмите здесь</span>. iFOREX имеет право по своему усмотрению отменить или изменить эти ограничения в любой момент, без предварительного уведомления.
              <br><br>
              <b>Хеджирование</b><br>
              Хеджирование определяется как открытие двух транзакций на том же инструменте или базовом активе в разных направлениях (одно "купить", а другое "продать"), независимо от того были ли эти транзакции открыты в одно время или нет, и независимо от того были ли они открыты на одинаковое количество или на разное. iFOREX рассматривает операции по хеджированию для целей расчета минимальной маржи на кумулятивной основе или на "чистой" основе. Кроме того, iFOREX рассматривает закрытие одной из транзакций хеджирования, как открытие новой транзакции на сумму равной транзакции которая осталась открытой.
              <br><br>
              <b>Неттинг транзакций</b><br>
              В том случае, когда необходимо закрыть более чем одну сделку одновременно, iFOREX проведёт закрытие всех открытых позиций как одну операцию. Нумерование транзакций по каждой закрытой позиции осуществляется на основе правил FIFO («первым пришёл — первым ушёл»). Это означает, что после закрытия позиций, под самым низким номером будет позиция которая была открыта первой, а под самым высоким номером будет позиция которая была открыта последней.
              <br><br>
              <b>Незаконная торговая практика</b><br>
              iFOREX поддерживает справедливую торговлю и не допускает использование запрещенных методов, таких как задержка торговли, манипуляции котировками и временем, или других незаконных методов и/или методов, которые могут использоваться, для предоставления несправедливого преимущества клиентам. Примером запрещенных методов, может быть один из перечисленных, но список не ограничивается только указанными методами:
              <ul class="list-style-disc-small mt-3 mb-2">
                 <li>
                    <b>Скальпинг</b> — это торговая стратегия, с помощью которой можно использовать небольшие изменения цен. Трейдеры, реализующие эту стратегию, создают множество краткосрочных позиций, обычно закрывая их в течение нескольких секунд или минут.
                 </li>
                 <li>
                    <b>Автоматизация</b> (например, EAs) или алгоритмическая торговля - использование электронных платформ для ввода торговых приказов с алгоритмом, который выполняет заранее запрограммированные указания. Такие указания могут включать в себя время, котировку и количество для осуществления определённого приказа, и во многих случаях размещать ордер с помощью "робота", без вмешательства человека.
                 </li>
                 <li>
                    <b>Автоматизированная торговля API</b> - программный интерфейс с помощью которого осуществляется любые торги, при этом используется определённая программа которая взаимодействует с другими программами. API действует в качестве посредника между трейдером и рынком, передавая приказы и извлекая информации по мере необходимости.
                 </li>
                 <li>
                    <b>"Несколько учетных аккаунтов"</b> относится к ситуации, когда один клиент настраивает две или более аккаунтов, чтобы случайно получить несколько связанных с учетной записью преимуществ от iFOREX.
                 </li>
              </ul>
              <p>Если у Компании есть какие-либо признаки или подозрения, по единоличному и абсолютному усмотрению Компании, в любой форме эксплуатации, незаконной, несправедливой, несанкционированной и/или оскорбительной торговой практики, используемой для предоставления Клиенту несправедливого преимущества, и/или мошенничества , манипулирование или нарушение соглашений, политика, положений и условий компании, компания имеет право по своему единоличному и абсолютному усмотрению и без умаления своих прав в соответствии с ее соглашениями с клиентом и применимым законодательством аннулировать и отменить все транзакции, проводимые на соответствующих счетах, включая всю прибыль или убытки, полученные на них, удалить любые бонусы, предоставленные клиенту, и/или блокировать счет.</p>
              <b>Ошибки в котировках</b><br>
              Онлайн технологии для ведения торгов не являются совершенными и в редких случаях передача данных может быть нарушена. Это может продолжаться лишь на мгновение, но когда это происходит, может произойти нежелательное влияние на котировки. У трейдера может возникнуть желание провести "арбитражную операцию", при этом он должен помнить, что котировки которые он видит не являются реальными и могут отличатся от реальных на много пунктов. В случае, если сделки осуществляются по котировкам которые не были предоставлены компанией iFOREX, iFOREX оставляет за собой право приостановить такие сделки, поскольку они не считаются действительными. Имейте в виду, что эти случаи, как правило встречаются редко, и приняв решение не вести торги в эти моменты, трейдеры могут избежать риска, связанного с указанными выше сценариями.
              <br><br>
              <b>Хранилище</b><br>
              Эта функция позволяет клиентам исключать средства, доступные на их счете, без того, чтобы эти средства были затронуты торговой активностью счета, и, по усмотрению клиента, могут быть восстановлены в любой момент времени для поддержки требований торговой маржи счета. Использование Хранилищa будет разрешено клиентам Компании по ее собственному усмотрению. В тех случаях, когда Хранилище предоставляется клиентам, будут применяться следующие условия: (i) бонусы, предоставленные Компанией, не могут быть распределены в Хранилище; (ii) восстановление средств обратно на счет клиента будет производиться в соответствии с суммами, которые изначально были распределены  в Хранилище, но не всеми накопленными суммами сразу (например, если клиент распределил 50$, а затем еще 100$ в Хранилище, клиент не сможет восстановить 150$ сразу, а разные суммы по отдельности, как изначально распределено); (iii) если счет становится неактивным, все средства, доступные в Хранилище, будут автоматически восстановлены Компанией на счет, а сборы за неактивность будут вычтены в соответствии с условиями раздела 13.3 Клиентского соглашения; (iv) Компания оставляет за собой право по своему усмотрению отказать в использовании Хранилища, изменить и обновить условия его использования, а также отменить его.
              <br><br>
              <b>Cборы за Неактивность </b><br>
              Со счетов клиентов, по которым не осуществлялась торговая деятельность в течение двенадцати (12) последовательных месяцев, может взиматься ежеквартальная комиссия за бездействие в размере 15 долларов США или весь капитал счета, если капитал составляет менее 15 долларов США.
              <br><br>
              <b>Комиссия за конвертацию валюты</b><br>
              Торговля финансовыми инструментами в валюте, отличной от валюты торгового счета клиента, может привести к уплате комиссии за конвертацию валюты.
              <br><br>
              При пополнении или снятии средств с торгового счета с помощью кредитной карты в валюте, отличной от валюты торгового счета, может взиматься комиссия за конвертацию, взимаемую компанией-эмитентом кредитной карты клиента.
              <br><br>
              <b>Недосягаемость и недоступность торговых услуг из определенных стран с ограниченным доступом</b><br>
              Торговая платформа и/или торговые услуги не будут доступны в определенных странах с ограниченным доступом, включая, помимо прочего, США. Для получения дополнительной информации об ограничениях на использование или доступность услуг или веб-сайтов Компании из определенных стран с ограниченным доступом, включая список стран с ограниченным доступом, пожалуйста, нажмите <a href="/legal/restricted-countries" target="_blank" rel="noopener">здесь</a>.
              <br><br>
              Для получения дополнительной информации посмотрите наши <a href="/legal/client_agreement.pdf" target="_blank" rel="noopener">Торговое соглашение</a>.
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "Форекс",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "Финансирование овернайт",
          content_before: `
                        <p>
                        При торговле CFD с широким кредитным плечом с помощью iFOREX ваши открытые сделки подлежат Овернайт финансированию в конце каждого торгового дня. Это Овернайт Финансирование может быть предметом кредита или дебета, рассчитанного на основе соответствующих процентных ставках для валют, в которых торгуется базовый инструмент, плюс надбавка. Наценка для валютных пар начинается с 0,75% и может быть выше, а также различаться между Длинными (Покупка) и Короткими (Продажа) позициями. Пожалуйста, ознакомьтесь с таблицей ниже, чтобы узнать последние уровни Ночного Финансирования.
                        <br><br>
                        Если рассчитанное процентное финансирование за ночь положительное, это означает, что соответствующая сумма будет добавлена (зачислена) на баланс вашего счета. Отрицательный процент финансирования овернайт означает, что соответствующая сумма будет вычтена (списонна) из вашего баланса.
                        <br><br>
                        Вы можете найти релевантное Овернайт Финансирование в процентах, суммах и связанные с ними сроки на Сделках, и Лимитах в разделе «Инструменты» во вкладке «Информация о рынке». Чтобы рассчитать Овернайт Финансирование, с которого будет дебетоваться или кредитоваться Ваш счет, просто умножьте процент Овернайт Финансирования на размер вашей сделки. Время процесса работы Овернайт Финансирование для каждого CFD подробно описано в «Информации инструмента» в разделе «Овернайт Финансирование (GMT)». Расчетная стоимость и процентная ставка «Овернайт Финансирование» инструмента применяются в течение 1 дня. CFD, которые торгуются 5 дней в неделю, будут зачислены или дебетованы со значением, в 3 раза превышающим отображаемое значение в течение последнего дня его основной торговой недели, так как оно охватывает весь период выходного дня. Сумма «Овернайт Финансирования» котируется в соответствии с валютой CFD. Однако, если котировка валюты CFD отличается от валюты счета, она будет конвертирована в валюту счета.
                        <br><br>
                        <u><b><u>Формула</u></b></u><br><br>
                        Расчет процентной ставки овернайт при Покупке (Длинные позиции):
                      <br>
  
                    <div class="formula formula_f1">
                        <div class="formula-name">Процент овернайт-финансирования</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">Средняя Процентная ставка 3M другой валюты - Средняя  Процентная ставка 3M базовой валюты + Длинная наценка</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                    <br>
                    Расчет процентной ставки овернайт при Продаже (Короткие позиции):
                      <br><br>
                      
                      <div class="formula formula_f2">
                        <div class="formula-name">Процент овернайт-финансирования</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">Средняя Процентная ставка 3M другой валюты - Средняя  Процентная ставка 3M базовой валюты - Короткая наценка</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                      Чтобы рассчитать сумму кредита овернайт, просто умножьте процент на сумму сделки:<br><br>Сумма финансирования за ночь = Сумма сделки X Процент овернайт-финансирования
                        <br><br><br>
                        <u><b><u>Примеры</u></b></u><br><br>
                        <b>Пример I</b><br><br>
                        Этот пример связан с ситуацией, когда Межбанковская Разница курсов выше, чем наценка. В таких случаях с Вашего счёта будут списываться средства, когда Вы зайдете на длинную позицию и зачислены средства, когда Вы зайдете на короткую позицию:
                        <br><br>
                        <ul class="list-style-dashed mb-4">
                            <li>Инструмент = EUR/USD (Евро пр. доллар США)</li>
                            <li>EUR (базовая валюта) средняя Процентная ставка 3M (в годовом выражении) = -0,37% = -0,0037</li>
                            <li>Долл. США (в другой валюте) средняя Процентная ставка 3M (в пересчете на год) = 1,08% = 0,0108</li>
                            <li>Разница межбанковских курсов = 1,45% = 0,0145</li>
                            <li>Длинная наценка = 0,75% = 0,0075</li>
                            <li>Короткая наценка = 0,75% = 0,0075</li>
                            <li>Величина Суммы сделки, выраженная другой в валюте = 106 550 долларов США (100 000 евро при текущем курсе закрытия 1.0655)</li>
                        </ul>
                        Процент финансирования за ночь при покупке (длинные позиции):<br><br>
                                            
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">Процент овернайт-финансирования</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                    Сумма финансирования за сутки = 106,550 × (-0.0000611) = -6.51 USD, что означает расход в размере 6.51 USD за день
                    <br><br><br>
                    Процент финансирования за ночь при продаже (короткие позиции):<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">Процент овернайт-финансирования</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                    Сумма финансирования за сутки = 106,550 × 0.00001944 = 2.07 USD доллара США в день
                    <br><br><br>
                    <b>Пример II</b><br><br>
                    Этот пример связан с ситуацией, когда Межбанковская Разница курсов выше, чем наценка а Длинные и Короткие наценки разные. В таких случаях с Вашего счета будут списываться средства каждую ночь независимо от направления вашей позиции:
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                       <li>Инструмент = EUR/TRY (Евро пр. Турецкой Лиры)</li>
                       <li>EUR (базовая валюта) средняя Процентная ставка 3M (в годовом выражении) = -0,37% = -0,0037</li>
                       <li>TRY (в другой валюте) средняя Процентная ставка 3М (в пересчете на год) = 22,75% = 0,2275</li>
                       <li>Разница межбанковских курсов = 23,12% = 0,2312</li>
                       <li>Длинная наценка = 0,75% = 0,0075</li>
                       <li>Короткая наценка = 14,00% = 0,14</li>
                       <li>Величина Суммы сделки, выраженная другой в валюте = 620 000 TRY (100 000 евро при текущем курсе закрытия 6.2000)</li>
                    </ul>
                    Процент финансирования за ночь при покупке (длинные позиции):<br><br>

                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">Процент овернайт-финансирования</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                        Сумма финансирования за сутки = 620,000 × (-0.000663) = -411 TRY, что означает расход в размере 411 TRY за день (~80 USD)
                        <br><br><br>
                        Процент финансирования за ночь при продаже (короткие позиции):<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">Процент овернайт-финансирования</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                        Сумма финансирования за сутки = 620,000 × (0.000253) = 157 TRY то есть 143,98 TRY кредита в день (~30 USD)
                        <br><br><br>
                        <b>Пример III</b><br><br>
                        Этот пример связан с ситуацией, когда Межбанковская Разница курсов ниже, чем отрицательная наценка. В таких случаях с Вашего счёта будут списываться средства, когда Вы зайдете на короткую позицию и зачислены средства, когда Вы зайдете на длинную позицию:
                        <ul class="list-style-dashed mt-4 mb-4">
                           <li>Инструмент = USD/JPY (доллар США пр. Японская йена)</li>
                           <li>USD (базовая валюта) средняя Процентная ставка 3M (в годовом выражении) = 1,08% = 1,08</li>
                           <li>JPY (в другой валюте) средняя Процентная ставка 3M (в пересчете на год) = -0,09% = -0,0009</li>
                           <li>Разница межбанковских курсов = -1,17% = -0,0117</li>
                           <li>Длинная наценка = 0,75% = 0,0075</li>
                           <li>Короткая наценка = 0,75% = 0,0075</li>
                           <li>Величина Суммы сделки, выраженная другой в валюте = 10 341 000 JPY (100 000 USD при текущем курсе закрытия 103,41)</li>
                        </ul>
                        Процент финансирования за ночь при покупке (длинные позиции):<br><br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">Процент овернайт-финансирования</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                        Сумма финансирования за сутки = 10 341 000 × 0,00001167 = 120,65 JPY доллара США в день (≅1,1 USD)
                        <br><br><br>
                        Процент финансирования за ночь при продаже (короткие позиции):<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">Процент овернайт-финансирования</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                        Сумма финансирования за сутки = 10 341 000 × (-0,0000533) = -551,52 JPY, что означает расход в размере 551,52 JPY за день (≅5,3 USD)
                     
                      
                   
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* В конце торгового дня расчеты по Овернайт Финансированию могут занять до 15 минут, после чего с вашего счета будет зачислена или списана сумма соответствующим образом.</p>`,
          table_titles: [
            "Инструмент",
            "Процент дневной процентной ставки овернайт (Продажа)",
            "Процент дневной процентной ставки овернайт (Покупка)",
            "Финансирование овернайт (GMT)*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "Индексы, Товары и Crypto (CFDs)",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "Финансирование овернайт",
          content_before: `
              <p>
               При торговле Индексами, Товарами и Криптовалютами CFDs с iFOREX ваши открытые сделки подлежат Овернайт финансированию в конце каждого торгового дня. Это Овернайт Финансирование может быть предметом кредита или дебета, рассчитанного на основе соответствующих процентных ставках для валют, в которых торгуется базовый инструмент, плюс надбавка. Наценка для Криптовалют может быть значительно выше из-за экстремальных рыночных условий относительно Криптовалют. Пожалуйста, ознакомьтесь с таблицей ниже, чтобы узнать последние уровни Овернайт Финансирования.
                <br><br>
                Если рассчитанное процентное финансирование за ночь положительное, это означает, что соответствующая сумма будет добавлена (зачислена) на баланс вашего счета. Отрицательный процент финансирования овернайт означает, что соответствующая сумма будет вычтена (списонна) из вашего баланса.
                <br><br>
                Вы можете найти релевантное Овернайт Финансирование в процентах, суммах и связанные с ними сроки на Сделках, и Лимитах в разделе «Инструменты» во вкладке «Информация о рынке». Чтобы рассчитать Овернайт Финансирование, с которого будет дебетоваться или кредитоваться Ваш счет, просто умножьте процент Овернайт Финансирования на размер вашей сделки. Время процесса работы Овернайт Финансирование для каждого CFD подробно описано в «Информации инструмента» в разделе «Овернайт Финансирование (GMT)». Расчетная стоимость и процентная ставка «Овернайт Финансирование» инструмента применяются в течение 1 дня. CFD, которые торгуются 5 дней в неделю, будут зачислены или дебетованы со значением, в 3 раза превышающим отображаемое значение в течение последнего дня его основной торговой недели, так как оно охватывает весь период выходного дня. Сумма «Овернайт Финансирования» котируется в соответствии с валютой CFD. Однако, если котировка валюты CFD отличается от валюты счета, она будет конвертирована в валюту счета.
                <br><br>
                <u><b><u>Формула</u></b></u><br><br>
                Расчет процентной ставки овернайт при Покупке (Длинные позиции):<br>
                  
                  <div class="formula formula_f9 mb-2">
                    <div class="formula-name">Процент овернайт-финансирования</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">Процентная ставка 3M + Наценка</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Расчет процентной ставки овернайт при Продаже (Короткие позиции):<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">Процент овернайт-финансирования</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Процентная ставка 3M - Наценка</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                Чтобы рассчитать сумму кредита овернайт, просто умножьте процент на сумму сделки:<br>Сумма финансирования за ночь = Сумма сделки X Процент овернайт-финансирования
                <br><br><br>
                <u><b><u>Примеры</u></b></u><br><br>
                <b>Пример I</b><br><br>
                Этот пример связан с ситуацией, когда ставка Межбанковского кредитования выше, чем наценка. В таких случаях с Вашего счёта будут списываться средства, когда Вы зайдете на длинную позицию и зачислены средства, когда Вы зайдете на короткую позицию:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Инструмент = Brazil Ibovespa</li>
                   <li>Процентная ставка Бразильского реала (BRL) 3M (в пересчете за год) = 9,567% = 0,0957</li>
                   <li>Наценка = 2,5% = 0,025</li>
                   <li>Величина Суммы сделки, выраженная в валюте = 127 380 BRL (2 индекс контракта при текущем курсе закрытия 63690 BRL за контракт)</li>
                </ul>
          
                Процент финансирования за ночь при покупке (длинные позиции):<br><br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">Процент овернайт-финансирования</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                Сумма финансирования за сутки = 127,380 × (-0.0003351944) = -42.70 BRL, что означает расход в размере 42.70 BRL за день (≅13.58 USD)
                <br><br><br>
                Процент финансирования за ночь при продаже (короткие позиции):<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">Процент овернайт-финансирования</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                Сумма финансирования за сутки = 127,380 × 0.00019630556 = 25 BRL доллара США в день (≅7.95 USD)
                <br><br><br>
                <b>Пример II</b><br><br>
                Этот пример связан с ситуацией, когда ставка Межбанковского кредитования ниже, чем наценка. В таких случаях с Вашего счета будут списываться средства каждую ночь независимо от направления вашей позиции:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Инструмент = Нефть (Crude Ligth WTI)</li>
                   <li>Доллар США (USD) Процентная ставка 3M (в пересчете на год) = 1,08% = 0,0108</li>
                   <li>Наценка = 2,5% = 0,025</li>
                   <li>Величина Суммы сделки, выраженная в валюте = 53 250 долл. США (1,000 баррелей нефти при текущем курсе закрытия 53,25 долл. США за баррель)</li>
                </ul>
             
                Процент финансирования за ночь при покупке (длинные позиции):<br><br>


                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">Процент овернайт-финансирования</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                    Сумма финансирования за сутки = 53,250 × (-0.00009944) = -5.30 USD, что означает расход в размере 5.30 USD за день
                    <br><br><br>
                    Процент финансирования за ночь при продаже (короткие позиции):<br><br>
                  
                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">Процент овернайт-финансирования</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                    Сумма финансирования за сутки = 53,250 × (-0.00003944) = -2.10 USD, что означает расход в размере 2.10 USD за день
                  <br><br>
                  
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* В конце торгового дня расчеты по Овернайт Финансированию могут занять до 15 минут, после чего с вашего счета будет зачислена или списана сумма соответствующим образом.</p>`,
          table_titles: [
            "Инструмент",
            "Процент дневной процентной ставки овернайт (Продажа)",
            "Процент дневной процентной ставки овернайт (Покупка)",
            "Финансирование овернайт (GMT)*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
          //id: "contracts_rollover_dates",
          id: "tc-view-3",
          title: "Контракты Ролловер",
          content_before: `<p>
                    Каждый CFD, который основан на будущий контракт (т.е. товары и индексы) имеет дату ролловера.
                    <br><br>
                    Достигнув даты ролловер при соответствующих инструментах, все открытые позиции будущих контрактов CFD, перенесутся на следующий контракт, так что позиции останутся открытыми с новым будущим контрактам.
                    <br><br>
                    При выполнении такого ролловера открытые P/L позиции (прибыль / убыток) выражают разницу цен между просроченными и новыми ценами контракта, а также включают разницу наценки. Все связанные уровни лимит ордеров должны автоматически корректироваться в соответствии с новой будущей ценой контракта.
                    <br><br>
                    Например, если последняя цена контракта (февраль) WTI Нефти составляет 50.125 долларов США, а рыночная цена следующего контракта (март) на тот момент составляет 50.805 долларов США, тогда уровень цен всех невыполненных лимитных заказов будет обновлен вверх на 0.68 доллара.
                    <br><br>
                    Срок Ролловера зависит от инструмента, которым Вы торгуете, что изложены ниже, должны быть единственным применимым ролловером в iFOREX CFD:
                  </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["Месяц контракта", "Контракт Ролловер (GMT)"],
          view_id: ["Commodity", "Index"],
          products: ["Товары", "Индексы"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "Акции и ETF CFDs",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "Финансирование овернайт",
          content_before: `<p>
                     При торговле Акциями и ETF на основе CFD с iFOREX ваши открытые сделки подлежат Овернайт Финансированию в конце каждого торгового дня. Это Овернайт Финансирование может быть предметом кредита или дебета, рассчитанного на основе соответствующих процентных ставках для валют, в которых торгуется базовый инструмент, плюс надбавка. Пожалуйста, ознакомьтесь с таблицей ниже, чтобы узнать последние уровни Овернайт Финансирования.
                    <br><br>
                    Если рассчитанное процентное финансирование за ночь положительное, это означает, что соответствующая сумма будет добавлена (зачислена) на баланс вашего счета. Отрицательный процент финансирования овернайт означает, что соответствующая сумма будет вычтена (списонна) из вашего баланса.
                    <br><br>
                    Вы можете найти релевантное Овернайт Финансирование в процентах, суммах и связанные с ними сроки на Сделках, и Лимитах в разделе «Инструменты» во вкладке «Информация о рынке». Чтобы рассчитать Овернайт Финансирование, с которого будет дебетоваться или кредитоваться Ваш счет, просто умножьте процент Овернайт Финансирования на размер вашей сделки. Время процесса работы Овернайт Финансирование для каждого CFD подробно описано в «Информации инструмента» в разделе «Овернайт Финансирование (GMT)». Расчетная стоимость и процентная ставка «Овернайт Финансирование» инструмента применяются в течение 1 дня. CFD, которые торгуются 5 дней в неделю, будут зачислены или дебетованы со значением, в 3 раза превышающим отображаемое значение в течение последнего дня его основной торговой недели, так как оно охватывает весь период выходного дня. Сумма «Овернайт Финансирования» котируется в соответствии с валютой CFD. Однако, если котировка валюты CFD отличается от валюты счета, она будет конвертирована в валюту счета.
                    <br><br>
                    <u><b><u>Формула</u></b></u><br><br>
                    Расчет процентной ставки овернайт при Покупке (Длинные позиции):<br>
                  
                  <div class="formula formula_f15 mb-2">
                    <div class="formula-name">Процент овернайт-финансирования</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">Процентная ставка 3M + Наценка</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Расчет процентной ставки овернайт при Продаже (Короткие позиции):

                <br><br>

                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">Процент овернайт-финансирования</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Процентная ставка 3M - Наценка</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>


                Чтобы рассчитать сумму кредита овернайт, просто умножьте процент на сумму сделки:<br><br>Сумма финансирования за ночь = Сумма сделки X Процент овернайт-финансирования
                <br><br><br>
                <u><b><u>Примеры</u></b></u><br><br>
                <b>Пример I</b><br><br>
                Этот пример связан с ситуацией, когда ставка Межбанковского кредитования выше, чем наценка. В таких случаях с Вашего счёта будут списываться средства, когда Вы зайдете на длинную позицию и зачислены средства, когда Вы зайдете на короткую позицию:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Инструмент = Газпром (GAZP)</li>
                   <li>Рубль (руб.) 3M Процентная ставка (в годовом исчислении) = 9,5% = 0,095</li>
                   <li>Наценка = 5% = 0,05</li>
                   <li>Величина Суммы сделки, выраженная в валюте = 2 459 000 руб. (20 000 акций по текущему курсу закрытия 122,95 руб. за акцию)</li>
                </ul>
              
                Процент финансирования за ночь при покупке (длинные позиции):<br><br>
                  
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">Процент овернайт-финансирования</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

                Сумма финансирования за сутки = 2,459,000 × (-0.0004) = -983.60 RUB, что означает расход в размере 983.60 RUB за день (≅17.52 USD)
                <br><br><br>
                Процент финансирования за ночь при продаже (короткие позиции):<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">Процент овернайт-финансирования</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                Сумма финансирования за сутки = 2,459,000 × 0.000125 = 307.38 RUB доллара США в день (≅5.48 USD)
                <br><br><br>
                <b>Пример II</b><br><br>
                Этот пример связан с ситуацией, когда ставка Межбанковского кредитования ниже, чем наценка. В таких случаях с Вашего счета будут списываться средства каждую ночь независимо от направления вашей позиции:
                <br><br>
                <ul class="list-style-dashed mb-4">
                    <li>Инструмент = Apple (AAPL)</li>
                    <li>Доллар США (USD) Процентная ставка 3M (в пересчете на год) = 1,08% = 0,0108</li>
                    <li>Наценка = 5% = 0,05</li>
                    <li>Величина Суммы сделки, выраженная в валюте = 70 600 долл. США (500 акций по текущему курсу закрытия 141,20 долл. США за акцию)</li>
                </ul>
           
                Процент финансирования за ночь при покупке (длинные позиции):<br><br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">Процент овернайт-финансирования</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                Сумма финансирования за сутки = 70,600 × (-0.000169) = -11.93 USD, что означает расход в размере 11.93 USD за день
                <br><br><br>
                Процент финансирования за ночь при продаже (короткие позиции):<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">Процент овернайт-финансирования</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>


                Сумма финансирования за сутки = 70,600 × (-0.000109) = -7.70 USD, что означает расход в размере 7.70 USD за день
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* В конце торгового дня расчеты по Овернайт Финансированию могут занять до 15 минут, после чего с вашего счета будет зачислена или списана сумма соответствующим образом.</p>`,
          table_titles: [
            "Инструмент",
            "Процент дневной процентной ставки овернайт (Продажа)",
            "Процент дневной процентной ставки овернайт (Покупка)",
            "Финансирование овернайт (GMT)*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "Дивиденд",
          content_before: `<p>
                        В случае перераспределения дивидендов акции CFD, корректировка будет осуществлена с баланса клиента по состоянию открытой сделки на конец рабочего дня, перед экс-дивидендной датой. Корректировка дивидендов рассчитывается исходя из размера дивидендов, размера позиции клиента, характера сделки: покупка или продажа. От позиции на покупку корректировка зачисляется на баланс клиента, позиции на продажу - списывается с баланса клиента во вне торговые часы акции до открытия следующего торгового дня - зависит от того, держит ли клиент соответствующую позицию открытой в момент корректировки дивидендов. В течение данного периода для того, чтобы сохранить стоимость акционерного капитала клиента до открытия следующего торгового дня, компания должна скорректировать позицию клиента в соответствии с суммой дивидендов по дебету или кредиту с/на баланса Клиента.
                        <br><br>
                        <u>Например:</u><br>
                        Coca-Cola выпускает дивиденды в размере 0,35 доллара США за акцию.<br>
                        Экс-дивидендная дата 29 ноября, значит, рассчетная дата iFOREX - 28 ноября в 22:05 по Гринвичу.<br>
                        Цена закрытия до урегулирования равна 41,65.<br>
                        Клиенту, который держит длительную позицию на покупку 5000 акций, будет начислено: 0,35 х 5000 = 1750 USD, если его сделка открыта в отчетный день.
                        <br>
                        Аналогичная сумма будет списана с баланса клиента, который держит позицию на продажу.<br>
                        Цена акций будет скорректирована после окончания рабочего дня с 41.65 до 41.30, что приравнивается последней цене акции за вычетом суммы дивидендов.
                      </p>`,
          data_id: "CorporateActions",
          no_information:"В настоящее время нет информации о будущих дивидендах",
          content_after: "",
          table_titles: [
            "Акция / ETF",
            "Рынок",
            "Сумма Дивиденда",
            "Дата и время (по Гринвичу)",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "Сплиты Акций и другие Корпоративные действия",
          content_before: `<p>
                    Корпоративные действия это определённые мероприятия, которые влияют на стоимость акций публичной акционерной компании. Если иное не указано в настоящем документе в отношении конкретных Корпоративных действий при наступлении корпоративного действия в отношении определённой акции, компания iFOREX должна ликвидировать любые позиции и ордера, которые были открыты/установлены на CFD на данную акцию.
                    <br><br>
                    К корпоративным действиям относятся: выплата дивидендов, консолидация, правовые предложения, а также многие другие мероприятия, которые могут оказать существенное влияние на цену акций (в том числе важные объявления, слияние, поглощение, заявление о неплатёжеспособности и т.д.).
                    <br><br>
                    <strong>
                    Особые правила сплитов и обратных сплитов акций
                    </strong>
                    <br>
                    Сплиты акций и обратные сплиты акций на бирже не изменяют общую стоимость акций для тех, кто ими владеет, а скорее изменяют количество акций и их цену. Эти сплиты обычно применяются, когда цена акций либо слишком высока, либо слишком низка. Если открытая сделка/лимит сталкивается со сплитом акций, его сумма, курс и связанный с ним уровень(-и) лимита(-ов) будут соответствующим образом скорректированы (включая баланс счета, в связи с требуемыми корректировками PL, если применимо).
                    <br><br>
                    Например, при разделении 1:10 1 акция становится 10 акциями после события, а цена делится на 10, оставляя общую стоимость акций неизменной. Например, 1 акция по цене 1000 долларов после события станет 10 акциями по 100 долларов: 1x 1000 долларов = 10 x 100 долларов = стоимость 1000 долларов.
                    <br><br>
                    Ниже вы найдёте список предстоящих корпоративных действий:
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"в настоящее время нет информации о будущих корпоративных действиях",
          table_titles: ["Акция / ETF", "Рынок", "Тип", "Дата и время (по Гринвичу)"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "Отчеты о Доходах",
          content_before: `<p>
                       Отчет о прибылях и убытках - это периодическая подача, сделанная публичными компаниями, чтобы сообщить о своей деятельности. Анализируя квартальные отчеты о прибылях и убытках, инвесторы могут оценить финансовое состояние компании. Объявление о доходах для компании, особенно для популярной компании с высокой рыночной капитализацией, может повлиять на цены ее акций, что может вызвать значительные колебания в дни, когда публикуются такие квартальные отчеты о доходах.
                        <br><br>
                        По этой причине максимальная сумма риска по соответствующим акциям будет снижена до 10 000 долларов США на протяжении всего периода публикации.
                       </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  